import * as React from "react";
import { useContactForm } from "./hooks/useContactForm.hook";
import { CloseIcon, CloseIconContainer, Text } from "./styles";
import { RECAPTCHA_SITE_KEY } from "../../../../../constants/consts";
import { useIsMobile } from "../../../../../hooks/useIsMobile.hook";
import { t } from "i18next";
import { LocalizedReCaptcha } from "./localizedReCaptcha";
import { Close as CloseOutlined, UIButton, UIForm, UIInput, UIModal, UITextArea } from "ui";

interface ContactFormModalProps {
    isContactModalOpen: boolean;
    toggleModal: VoidFunction;
}

export const ContactFormModal = ({ isContactModalOpen, toggleModal }: ContactFormModalProps) => {
    const isMobile = useIsMobile();
    const { formData, handleChange, handleSubmit, handleCaptchaChange } = useContactForm({ isContactModalOpen });

    return (
        <UIModal
            open={isContactModalOpen}
            onClose={toggleModal}
            className="products__modal"
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            width={isMobile ? "90%" : "50%"}
            centered
            destroyOnClose
        >
            <div style={{ maxHeight: "95vh", overflowY: "auto", position: "relative" }}>
                <CloseIconContainer onClick={toggleModal}>
                    <CloseIcon>
                        <CloseOutlined />
                    </CloseIcon>
                </CloseIconContainer>
                <div
                    style={{
                        fontSize: 24,
                        fontWeight: 600,
                        paddingLeft: isMobile ? 16 : 32,
                        paddingRight: isMobile ? 16 : 32,
                        marginBottom: 8,
                    }}
                >
                    {t("contact_form")}
                </div>
                <UIForm
                    sx={{
                        paddingLeft: isMobile ? 16 : 32,
                        paddingRight: isMobile ? 16 : 32,
                        paddingBottom: isMobile ? 24 : 32,
                    }}
                    onSubmit={handleSubmit}
                >
                    <div style={{ marginTop: 8, marginBottom: 8 }}>
                        <Text>{t("helpful_text")}</Text>
                    </div>
                    <UIInput
                        required
                        fullWidth
                        label={t("name_field_label")}
                        name="name"
                        margin="normal"
                        variant="outlined"
                        value={formData.name}
                        onChange={handleChange}
                        sx={{ borderRadius: 2, backgroundColor: "#fff" }}
                    />
                    <UIInput
                        required
                        fullWidth
                        label={t("phone_number_field_label")}
                        name="phone"
                        margin="normal"
                        variant="outlined"
                        value={formData.phone}
                        onChange={handleChange}
                        sx={{ borderRadius: 2, backgroundColor: "#fff" }}
                    />
                    <UIInput
                        required
                        fullWidth
                        label={t("email_address_field_label")}
                        name="email"
                        type="email"
                        margin="normal"
                        variant="outlined"
                        value={formData.email}
                        onChange={handleChange}
                        sx={{ borderRadius: 2, backgroundColor: "#fff" }}
                    />
                    <div style={{ marginTop: 16, marginBottom: 16 }}>
                        <label style={{ display: "block", marginBottom: 6 }}>
                            {t("comments_field_label")}
                        </label>
                        <UITextArea
                            required
                            fullWidth
                            name="message"
                            rows={3}
                            value={formData.message}
                            onChange={handleChange}
                            sx={{ borderRadius: 8, backgroundColor: "#fff" }}
                        />
                    </div>
                    <div style={{ marginTop: 16, marginBottom: 16 }}>
                        <LocalizedReCaptcha
                            siteKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || RECAPTCHA_SITE_KEY}
                            onChange={handleCaptchaChange}
                        />
                    </div>
                    <UIButton
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                            marginTop: 8,
                            paddingTop: 12,
                            paddingBottom: 12,
                            fontWeight: 500,
                            backgroundColor: "#006AFF",
                            borderRadius: 8,
                        }}
                    >
                        {t("send_message")}
                    </UIButton>
                </UIForm>
            </div>
        </UIModal>
    )
}
